import script from "./childrenMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./childrenMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./childrenMenuItem.vue?vue&type=style&index=0&id=8d3758d2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d3758d2"]])

export default __exports__